export const increaseProfileScoreModal = {
  iWantToIncreaseProfileScore: 'wui-i-want-to-increase-my-profile-score-first-click',
  applyWithALowerScore: 'wui-apply-with-a-lower-profile-score-click',
};
